// extracted by mini-css-extract-plugin
export default {"container":"Info_container__QPOvl","info_button":"Info_info_button__D8XpW"};